module.exports = __webpack_public_path__ + "img/Holds.6377b736.svg";